import { ActionCard } from '../../ActionCard';

export type TaskActionsLoadingSkeletonProps = {
  /**
   * Number of skeleton radio option rows to display
   */
  optionCount?: number;
  /**
   * Class name for additional styling
   */
  className?: string;
};

/**
 * Skeleton loading state for task action cards with radio options.
 * Displays placeholder rows that mimic the layout of radio option groups.
 */
export const TaskActionsLoadingSkeleton = ({ optionCount = 3, className }: TaskActionsLoadingSkeletonProps) => (
  <ActionCard className={className}>
    <div className="flex w-full flex-col gap-2">
      {[...Array(optionCount)].map((_, i) => (
        <div key={i} className="flex items-center gap-2 rounded-medium border border-grayscale-50 p-2">
          <div className="size-4 shrink-0 animate-pulse rounded-full bg-grayscale-100" />
          <div className="h-4 animate-pulse rounded bg-grayscale-100" style={{ width: `${50 + i * 15}%` }} />
        </div>
      ))}
    </div>
  </ActionCard>
);
